<template>
  <div style="background-color: #EDF1F7;" :class="{'mobile-member-ship-container':isMobile}">
    <header class="header-bg" v-if="!centerDisplay" >
      <div><span @click="$router.push('/')">首页</span> > 会员权益</div>
      <div>云课堂VIP会员超值服务</div>
      <div>最新、最好、最全的教学视频</div>
    </header>
    <div class="box" :class="{'center-display':centerDisplay}">
      <div class="member-msg-box"  :class="{'diamond-bg':userInfo.memberFlag==2}">
        <img :src="memberDisplay().icon" alt="">
        <div class="member-prerogative">
          <div>会员特权</div>
          <div>会员到期时间：{{ userInfo.member.expiryTime }}</div>
        </div>
        <button @click="$router.push('/other/member-ship')">
          {{ userInfo.memberFlag == 0 ? '立即开通' : '立即续费' }}
        </button>
      </div>
      <div class="member-power">
        <div><span>{{ memberDisplay().name }}权益</span><span v-if="!isMobile">联系工作人员，获取相关权益</span>
        </div>
        <div v-if="!isMobile" class="customer-service">
          <span>客服电话：{{phoneNum}}</span>
          <span v-for="(item,index) in qqList" :key="item.dictValue">客服{{index+1}}QQ：{{item.dictValue.split(',')[0]}}</span>
        </div>
        <div v-else class="mobile-qq">
          联系工作人员，获取相关权益（QQ：{{qqList[0].dictValue.split(',')[0]}}）
        </div>
      </div>
      <div class="power-list-box">
        <div  v-for="(item,index) in memberData" :key="index">
          <img :src="item.picUrl" alt="">
          <div>{{item.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@/mixin/common";
import {memberDisplay} from "@utils/common";
import {mapState} from "vuex";
import {systemDictText} from "@api/course-live-online";
import { myMemberData} from "@api/vip";

export default {
  mixins: [common],
  props:{
    centerDisplay:Boolean
  },
  data(){
    return  {
      displayList:[],
      memberData:[],
      qqList:[],
      phoneNum:'',

    }
  },
  created() {
    this.initData()
  },
  methods: {

    memberDisplay,
   async initData()  {
     await systemDictText('member_benefits').then(res => {
        this.displayList = res.rows
        console.log(this.displayList)
      })
    await  myMemberData().then(res=>{
       this.memberData=res.data.memberDetailsList.map(item=>{
         return {
           ...item,
           title:this.displayList.find(value=>{
             return value.dictValue == item.memberBenefits
           })['dictLabel']
         }
       });
      })
      systemDictText('qq_list').then(res=>{
        this.qqList=res.rows
      })
      systemDictText('es_phone').then(res=>{
        this.phoneNum=res.rows[0].dictLabel
      })
    },
  },
  computed: {
    ...mapState({
      userInfo: state => state.login.userInfo
    })
  },

}
</script>

<style scoped lang="less">
.diamond-bg{
  background-image: url("~@assets/img/member-ship/diamond-bg.png") !important;
}
.center-display{
  margin-top: 0!important;
  width: 100% !important;
  border-radius: unset !important;
}
.header-bg {
  width: 1200px;
  margin: 0 auto;
  background: url("~@assets/img/member-ship/member-ship-bg.png");
  height: 332px;
  color: #fff;
  padding: 20px;
  font-weight: 500;

  > div {
    span {
      cursor: pointer;
    }
  }

  & > :nth-child(2) {
    margin-top: 35px;
    font-size: 40px;
    color: #fff;
    text-align: center;
  }

  & > :nth-child(3) {
    margin-top: 20px;
    font-size: 20px;
    color: #9196a3;
    text-align: center;
  }
}

.box {
  margin-top: -112px;
  background: linear-gradient(180deg, #FFFFFF 0%, #EDF1F7 100%);
  border-radius: 15px;
  position: relative;
  font-weight: 500;
  padding: 20px 26px;
  color: #333;
  paddingn-bottom:15px;
  .member-display {
    width: 100%;
    height: 96px;
    background: url("~@assets/img/member-ship/member-bg.png");
    background-size: 100% 100%;

  }
  .member-power{
    position: relative;
    display: flex;
    justify-content: space-between;
    margin-top: 28px;
    &::after {
      display: block;
      position: absolute;
      content: '';
      left: -6px;
      top: 4px;
      width: 2px;
      height: 14px;
      background: #00B278;
      border-radius: 1px;
    }
    &>:nth-child(1){
     &>:nth-child(1){
       margin-left: 3px;
       font-weight: 600;
       margin-right: 11px;
     }
      &>:nth-child(2){
        font-size: 12px;
        color: #8E8C8C;
      }
    }
    .customer-service{
      &>:last-child{
        &::after{
          width: 0 !important;
        }
      }
      span{
        margin-left: 30px;
        font-size: 12px;
        position: relative;
        &::after{
          display: block;
          content: '';
          position: absolute;
          right: -15px;
          top: 1px;
          width: 1px;
          height: 15px;
          background: #F3F5F8;
        }

      }
    }
  }
  .power-list-box{
    display: flex;
    flex-wrap: wrap;
    position: relative;
    margin-top: 46px;

    &::after{
      display: block;
      content: '';
      width: 1160px;
      height: 1px;
      background: #F3F5F8;
      position: absolute;
      left: -29px;
      top: -29px;

    }
    >div{
      width: 25%;
      text-align: center;
      margin-bottom: 36px;
      color: #333333;
      font-size: 16px;
      font-weight: 600;
      img{
        width: 96px;
        margin-bottom: 15px;
      }
    }
  }
}

.member-msg-box {
  padding: 0 44px;
  width: 100%;
  height: 88px;
  background-image: url("~@assets/img/member-ship/member-bg.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;

  img {
    width: 51px;
    margin-right: 12px;
  }

  > button {
    width: 96px;
    height: 25px;
    background: linear-gradient(90deg, #DC8E5E 0%, #A7461B 100%);
    border-radius: 13px;
    font-weight: 600;
    color: #A7461B;
    font-size: 12px;
    border: none;
    margin-left: auto;
    color: #fff;
    cursor: pointer;
  }

  .member-prerogative {
    & > :nth-child(1) {
      font-size: 23px;
      color: #333;
      margin-bottom: 4px;
    }

    & > :nth-child(2) {
      font-size: 12px;
      color: #8E8C8C;
      margin-bottom: 4px;
    }

  }
}
.mobile-member-ship-container {
  .header-bg {
    width: 100%;
    height: 140px;

    & > :nth-child(2) {
      font-size: 16px;
      margin-top: 10px;
    }

    & > :nth-child(3) {
      font-size: 12px;
      margin-top: 6px;
    }
  }
  .box{
    width: 90%;
    margin-top: -30px;
    padding: 11px;
    min-height:calc(100vh - 160px);
    background:#fff;
    .member-power{
      margin-left: 10px;
      flex-direction: column;
      .mobile-qq{
        font-size: 12px;
        color: #999999;
        margin-left:3px;
      }
    }
  }
  .power-list-box{
    margin-top: 39px;
    &::after{
      top: -20px;
    }
    >div{
      width: 50%;
      font-size: 13px;
      img{
        width: 72px;
      }
    }
  }
  .member-msg-box {
    padding:13px 19px;
    width: 100%;
    height: 62px;

    img {
      width: 27px;
      margin-right: 12px;
    }

    > button {
      width: 71px;
      height: 26px;
      background: linear-gradient(90deg, #DC8E5E 0%, #A7461B 100%);
      border-radius: 13px;
      font-weight: 400;
      color: #A7461B;
      font-size: 12px;
      border: none;
      margin-left: auto;
      color: #fff;
      cursor: pointer;
    }

    .member-prerogative {
      & > :nth-child(1) {
        font-size: 13px;
        margin-bottom: 4px;
      }

      & > :nth-child(2) {
        font-size: 12px;
        margin-bottom: 4px;
      }

    }
  }
}

</style>
